<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="16"
        viewBox="0 0 20 16"
        fill="none"
    >
        <path
            d="M17.9571 15.1616C16.8278 15.1616 15.9099 14.2471 15.9099 13.1144V9.08235L11.1538 4.32633C10.3537 3.52615 10.3537 2.23409 11.1538 1.43392C11.954 0.633741 13.2495 0.637205 14.0462 1.43392L19.4015 6.7892C19.786 7.1737 20.0008 7.6933 20.0008 8.23714V13.1179C20.0008 14.2471 19.0863 15.1651 17.9536 15.1651L17.9571 15.1616Z"
            fill="url(#paint0_linear_195_83)"
        />
        <path
            d="M2.04766 15.1611C0.918409 15.1611 0.000457764 14.2467 0.000457764 13.1139V10.0414C0.000457764 8.91215 0.914945 7.9942 2.04766 7.9942C3.18038 7.9942 4.09486 8.90869 4.09486 10.0414V13.1139C4.09486 14.2432 3.18038 15.1611 2.04766 15.1611Z"
            fill="url(#paint1_linear_195_83)"
        />
        <path
            d="M12.6024 15.1613C11.4732 15.1613 10.5552 14.2468 10.5552 13.1141V2.88155C10.5552 1.7523 11.4697 0.834351 12.6024 0.834351C13.7352 0.834351 14.6496 1.74883 14.6496 2.88155V13.1141C14.6496 14.2434 13.7352 15.1613 12.6024 15.1613Z"
            fill="url(#paint2_linear_195_83)"
        />
        <path
            d="M7.26454 15.1613C6.13529 15.1613 5.21735 14.2468 5.21735 13.1141V6.19656C5.21735 5.0673 6.13183 4.14935 7.26454 4.14935C8.39726 4.14935 9.31175 5.06384 9.31175 6.19656V13.1141C9.31175 14.2433 8.39726 15.1613 7.26454 15.1613Z"
            fill="url(#paint3_linear_195_83)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_195_83"
                x1="14.0913"
                y1="3.17629"
                x2="22.4602"
                y2="19.9696"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0.04" stop-color="#6439FF" />
                <stop offset="0.99" stop-color="#A78FFF" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_195_83"
                x1="1.92296"
                y1="16.5675"
                x2="2.2174"
                y2="4.61684"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#7543FF" />
                <stop offset="0.99" stop-color="#A78FFF" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_195_83"
                x1="12.3911"
                y1="16.7166"
                x2="12.6648"
                y2="5.53495"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#7543FF" />
                <stop offset="0.99" stop-color="#A78FFF" />
            </linearGradient>
            <linearGradient
                id="paint3_linear_195_83"
                x1="7.09828"
                y1="16.5919"
                x2="7.36847"
                y2="5.45527"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#7543FF" />
                <stop offset="0.99" stop-color="#A78FFF" />
            </linearGradient>
        </defs>
    </svg>
</template>
